import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "review",
  class: "w-full"
}
const _hoisted_2 = { class: "stepper__title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-70" }, "You will need", -1)
const _hoisted_4 = {
  key: 0,
  class: "opacity-70"
}
const _hoisted_5 = {
  key: 1,
  class: "opacity-70"
}
const _hoisted_6 = { class: "w-full flex justify-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-left mb-2" }, "By continuing, I acknowledge that:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "/privacy-policy",
  target: "_blank",
  class: "underline"
}, "Privacy Policy", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "/terms",
  target: "_blank",
  class: "underline"
}, "Terms of Service", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nft_preview = _resolveComponent("nft-preview")!
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_nomad_button = _resolveComponent("nomad-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", null, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.nativeToken) + " ", 1),
      (_ctx.affected)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " to complete the bridge transfer on Ethereum and mint your NFT. This NFT can be used to access recovered ETH pro rata. "))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, " to complete the bridge transfer on " + _toDisplayString(_ctx.getDisplayName(_ctx.userInput.destinationNetwork)) + " and receive your " + _toDisplayString(_ctx.userInput.token.symbol) + ". ", 1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_nft_preview, {
        size: 230,
        asset: _ctx.token.tokenIdentifier.id,
        amount: _ctx.userInput.sendAmount,
        affected: _ctx.affected,
        class: "my-4 mx-auto"
      }, null, 8, ["asset", "amount", "affected"])
    ]),
    _hoisted_7,
    (_ctx.affected)
      ? (_openBlock(), _createBlock(_component_n_checkbox, {
          key: 0,
          checked: _ctx.checkbox1,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkbox1) = $event)),
          class: "text-left"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" I will receive an NFT that can be used to access recovered funds ")
          ]),
          _: 1
        }, 8, ["checked"]))
      : _createCommentVNode("", true),
    _createVNode(_component_n_checkbox, {
      checked: _ctx.checkbox2,
      "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkbox2) = $event)),
      class: "text-left"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" I have read and agree to the "),
        _hoisted_8,
        _createTextVNode(" and "),
        _hoisted_9
      ]),
      _: 1
    }, 8, ["checked"]),
    _createVNode(_component_nomad_button, {
      primary: "",
      class: "stepper__continue",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next'))),
      disabled: !_ctx.valid
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Confirm ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_nomad_button, {
      class: "w-full flex justify-center",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('back')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Back ")
      ]),
      _: 1
    })
  ]))
}